import { combineReducers } from "redux";
import ewGroup from './ewGroupReducer'
import ewCo from './ewCompanyReducer'
import user from './userReducer'
export default combineReducers({
ewGroup, ewCo, user
});
